// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3VZ0i","footer":"Form_footer__Mwm3R"};